<template>
  <gj-modal
      size="normal"
      :visible.sync="modalVisible"
  >
    <template #header>导入</template>
    <template #content>
      <div
          v-loading="loading"
          element-loading-text="文件上传成功，正在验证导入文件验证"
          element-loading-spinner="el-icon-loading"
      >
        <div class="gj-mb16">
          <div class="gj-mb16">

            <gj-required>店铺/国家</gj-required>
            <gj-market-select
                style="margin-left: 10px"
                v-model="marketId"
                :clearable="false"
                width="120px"
                @input-option="inputOption"
            ></gj-market-select>

            <gj-required style="margin-left: 30px">数据月份</gj-required>
            <gj-date-picker
                style="margin-left: 10px"
                type="month"
                v-model="recordMonth"
                :clearable="false"
                width="120px"
            ></gj-date-picker>

          </div>
          <gj-upload
              :disabled="marketId === null || recordMonth === null"
              container-type="dateRangeReport"
              @uploadAfter="uploadAfter"
              :validFileSize="200"
              :acceptType="[FileTypeEnum.CSV, FileTypeEnum.X_CSV, FileTypeEnum.XLS, FileTypeEnum.XLSX, FileTypeEnum.X_XLS]"
          >
            <template #tip>
              <span>只能上传CSV/XLS文件</span>
            </template>
          </gj-upload>
        </div>
        <gj-import-alert
            :rules="[
            `导入需要指定站点`,
            `导入数据必须是原文件CSV/XLS格式`,
            `导入的文件不能超过200M`,
            `系统发现重复报告，根据记录时间新数据会替换掉旧的数据`,
          ]">
        </gj-import-alert>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import {FileTypeEnum} from "@/components/upload/enum";
import {modalMixIn, uploadMixin} from "@/minxins";
import {convertToMonth} from "@/utils/date.util";
import {dateRangeImport} from "@/api/statistics";

export default {
  name: "add-import-modal",
  mixins: [modalMixIn, uploadMixin],
  data() {
    return {
      loading: false,
      FileTypeEnum,
      countryCode: null,
      marketId: null,
      recordMonth: null,
    }
  },
  methods: {
    inputOption(option) {
      this.countryCode = option.countryCode;
      this.marketId = option.id;
    },
    uploadAfter(attId, data, uploadCb) {
      this.loading = true;
      dateRangeImport({
        attachmentId: attId,
        countryCode: this.countryCode,
        marketId: this.marketId,
        recordMonth: convertToMonth(this.recordMonth)
      }).then(res => {
        if (res.code !== 0) {
          this.$gjMessage.error(res.msg);
        } else {
          this.$gjMessage.success('导入成功！正在后台更新数据，请稍等');
          uploadCb(res)
          this.$emit('importSuccess');
        }
      }).catch(() => {
        uploadCb('error')
      }).complete(() => {
        this.loading = false
        this.$emit('import');
      });
    },
    // uploadAfter(attId, data, uploadCb) {
    //   this.loading = true;
    //   let params = `attachmentId=${attId}&recordMonth=${convertToMonth(this.recordMonth)}&countryCode=${this.countryCode}&marketId=${this.marketId}`
    //   dateRangeImport(params).then((res) => {
    //     this.$gjImportHandle(res, uploadCb);
    //   }).catch(() => {
    //     uploadCb('error')
    //   })
    //       .complete(() => this.loading = false);
    // }
  }
}
</script>

<style scoped>

</style>